<script setup lang="ts">
interface Props {
  suppliers: Supplier[]
  supplierShown?: boolean
  displayProductList?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  displayProductList: true,
})

const emit = defineEmits<{
  (e: 'toggleSupplier'): void
}>()
const localePath = useLocalePath()
async function handleSupplierClick() {
  emit('toggleSupplier')
}
</script>

<template>
  <vmz-card
    v-if="props.displayProductList"
    flat
    class="d-flex align-center py-3 px-5 w-100 rounded-t-0"
    data-track-id="product_toggle_other_suppliers"
    @click="handleSupplierClick"
  >
    <div v-if="!props.supplierShown" class="d-flex align-center">
      <p class="text-body-sm text-vm-grey-8">
        {{ $t('product.alsoAvailableFrom') }}
      </p>
      <NuxtImg
        v-for="supplier in props.suppliers"
        :key="supplier.name"
        :src="supplier.supplier.imageUrl"
        class="mx-4"
        width="60"
        height="60"
      />
    </div>
    <vmz-icon
      :icon="props.supplierShown ? 'veticon-chevron-up' : 'veticon-chevron-down'"
      :class="props.supplierShown ? 'my-3' : ''"
      variant="text"
      class="ml-auto"
    />
  </vmz-card>
  <vmz-card
    v-else
    flat
    class="d-flex align-center justify-space-between pt-5 pb-3 px-5 w-100 border-t-sm rounded-t-0"
  >
    <div v-if="!props.supplierShown" class="d-flex align-center">
      <p class="text-body-sm text-vm-grey-8">
        {{ $t('product.alsoAvailableFrom') }}
      </p>
      <NuxtLink
        v-for="supplier in props.suppliers"
        :key="supplier.name"
        :to="localePath(`/product/${supplier.supplier.handle}/${supplier.items[0].product.idExternal}`)"
        data-nav-id="product_other_supplier_link"
      >
        <NuxtImg
          :src="supplier.supplier.imageUrl"
          class="mx-4"
          width="60"
          height="60"
        />
      </NuxtLink>
    </div>
  </vmz-card>
</template>
